import styled from '@emotion/styled';
import { Css, Link } from '../../../ui';
import DownloadApple from '../../../assets/download-apple.png';
import DownloadGoogle from '../../../assets/download-google.png';
import {
	ISocialLinkItem,
	ISocialLinkItemPlatform,
} from '../social-links/SocialLinks';

export const FooterStoreLink = (link: ISocialLinkItem) => (
	<Link
		key={link?.url}
		href={link?.url}
		title={link?.platform}
		target="_blank"
		rel="noopener"
		hideExternalIndicator
	>
		<StyledStoreImg
			src={
				link?.platform === ISocialLinkItemPlatform.AppStore
					? DownloadApple
					: DownloadGoogle
			}
			alt={`Download on the ${link?.platform}`}
		/>
	</Link>
);

const StyledStoreImg = styled.img`
	width: ${Css.pxToRem(120)};
`;
